import { Modal } from './modal';

export class SearchModal extends Modal {
    constructor() {
        super(document.querySelector('.js-search-modal'));
        /**
         * @type {Element}
         * @protected
         */
        this._button = document.querySelector('.js-search-modal-button');
        this.onButtonClick = this.onButtonClick.bind(this);
        if (this._button) {
            this._button.setAttribute('role', 'button');
            this._button.addEventListener('click', this.onButtonClick);
        }
    }

    /**
     * @param {MouseEvent} e
     */
    onButtonClick(e) {
        e.preventDefault();
        this.open = !this.open;
    }

    set open(value) {
        const wasOpen = this.open;
        super.open = value;
        document.body.style.overflow = value ? 'hidden' : null;
        if (value && value !== wasOpen) {
            const input = this._modal.querySelector('input[type=search]');
            if (input) {
                input.focus();
            }
        }
        if (!value && this._button) {
            this._button.focus();
        }
    }

    get open() {
        return super.open;
    }
}
